import { Participant } from 'livekit-client';
import React, { useState, useEffect, useRef } from 'react';
import { BasePlaceholderProps, PlaceholderWrapper } from 'features/ParticipantItem/presenters/view';
import { useParticipantMetadata } from 'useCase/participant/useParticipantMetadata';
import { AvatarImage } from './view';
import { PulseAnimation } from './PulseAnimation/PulseAnimation';

interface Props {
    children?: React.ReactNode;
    participant: Participant;
    isShowPulseAnimation?: boolean;
    PresenterPlaceholder: React.ComponentType<BasePlaceholderProps>;
}

const AvatarImpl = ({ children, participant, PresenterPlaceholder, isShowPulseAnimation = false }: Props) => {
    const participantId = participant.sid;
    const { getAvatarFromMetadata } = useParticipantMetadata();
    const [avatar, setAvatar] = useState<string | undefined>(undefined);
    const presenterRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        (async () => {
            const newAvatar = await getAvatarFromMetadata(participant.metadata);
            setAvatar(newAvatar);
        })();
    }, [participant]);

    return (
        <PlaceholderWrapper>
            {!!presenterRef?.current && <PulseAnimation isOn={isShowPulseAnimation} presenterRef={presenterRef} />}
            <PresenterPlaceholder participantId={participantId}>
                {avatar ? <AvatarImage src={avatar} draggable="false" /> : children}
            </PresenterPlaceholder>
        </PlaceholderWrapper>
    );
};

export const Avatar = React.memo(AvatarImpl);
